import { Validator } from '../Validator';

export default class FileSizeService implements Validator {

  // tslint:disable-next-line no-any
  public getValidation(file: any, message: string = 'fileSize'): Promise<void> {
    return new Promise(
      (res, error) => {
        if ((file) && (file.size < 20000000)) {
          res();
        } else {
          error(message);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/validation/validators/FileSize.tsx